import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectError,
  selectHasUnseen,
  selectLoading,
  selectNotifications,
  selectUnseenCount,
} from './notification.selectors';

@Injectable({ providedIn: 'root' })
export class NotificationSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly notifications = this._store.selectSignal(selectNotifications);

  public readonly unseenCount = this._store.selectSignal(selectUnseenCount);

  public readonly hasUnseen = this._store.selectSignal(selectHasUnseen);

  public readonly loading = this._store.selectSignal(selectLoading);

  public readonly error = this._store.selectSignal(selectError);
}
